import {getOutlet} from 'reconnect.js';

function getFeatureOptions() {
  try {
    return getOutlet('FeatureOptions').getValue() || {};
  } catch (e) {
    return {};
  }
}

const gtag = (eventType, event, payload) => {
  try {
    if (typeof window === 'undefined') {
      return;
    }

    const featureOptions = getFeatureOptions();
    if (featureOptions.googleAnalytics === false) {
      return;
    }

    const actions = getOutlet('actions').getValue();
    const shouldContinue =
      typeof actions?.gtag === 'function'
        ? actions.gtag(eventType, event, payload)
        : true;

    if (!shouldContinue) {
      return;
    }

    window.gtag?.(eventType, event, payload);
  } catch (e) {
    console.log('google analytics is not ready');
  }
};

const fbq = (eventType, event, payload) => {
  try {
    if (typeof window === 'undefined') {
      return;
    }

    const featureOptions = getFeatureOptions();
    if (featureOptions.facebookPixel === false) {
      return;
    }

    const actions = getOutlet('actions').getValue();
    const shouldContinue =
      typeof actions?.fbq === 'function'
        ? actions.fbq(eventType, event, payload)
        : true;

    if (!shouldContinue) {
      return;
    }

    window.fbq?.(eventType, event, payload);
  } catch (e) {
    console.log('facebook pixel is not ready');
  }
};

const tracker = {
  removeFromCart: ({cartItem}) => {
    if (!cartItem?.product) {
      return;
    }

    gtag('event', 'remove_from_cart', {
      currency: 'TWD',
      value: cartItem.product.price,
      items: [
        {
          item_id: cartItem.product.id?.$oid || cartItem.product.id,
          item_name: cartItem.product.name,
        },
      ],
    });
  },
  beginCheckout: ({cart}) => {
    gtag('event', 'begin_checkout', {
      currency: 'TWD',
      value: cart.total,
      items: (cart.items || []).map((i) => ({
        item_id: i.product.id?.$oid || i.product.id,
        item_name: i.product.name,
      })),
    });

    fbq('track', 'InitiateCheckout', {
      content_category: 'checkout',
      content_ids: (cart.items || []).map(
        (i) => i.product.id?.$oid || i.product.id,
      ),
      contents: (cart.items || []).map((i) => ({
        id: i.product.id?.$oid || i.product.id,
        quantity: i.config.qty,
      })),
      num_items: (cart.items || []).length,
      currency: 'TWD',
      value: cart.total,
    });
  },
  viewCart: ({cart}) => {
    gtag('event', 'view_cart', {
      currency: 'TWD',
      value: cart.total,
      items: (cart.items || []).map((i) => ({
        item_id: i.product.id?.$oid || i.product.id,
        item_name: i.product.name,
      })),
    });
  },
  addCheckoutInfo: ({cart}) => {
    gtag('event', 'add_payment_info', {
      currency: 'TWD',
      value: cart.total,
      payment_type: 'ecpay',
      payment_subtype: cart.payment_subtype,
      items: (cart.items || []).map((i) => ({
        item_id: i.product.id?.$oid || i.product.id,
        item_name: i.product.name,
      })),
    });

    gtag('event', 'add_shipping_info', {
      currency: 'TWD',
      value: cart.total,
      logistics_type: cart.logistics_type,
      logistics_subtype: cart.logistics_subtype,
      items: (cart.items || []).map((i) => ({
        item_id: i.product.id?.$oid || i.product.id,
        item_name: i.product.name,
      })),
    });

    fbq('track', 'AddPaymentInfo', {
      content_category: 'checkout',
      content_ids: (cart.items || []).map(
        (i) => i.product.id?.$oid || i.product.id,
      ),
      contents: (cart.items || []).map((i) => ({
        id: i.product.id?.$oid || i.product.id,
        quantity: i.config.qty,
      })),
      currency: 'TWD',
      value: cart.total,
    });
  },
};

export {gtag, fbq};
export default tracker;
